import { ShieldBugOutlineIcon } from './ShieldBugOutlineIcon';

/**
 * author: MaksUr
 * id DCD9B7FB-8730-4C65-8805-50B6B51A5EF7
 * name shield-bug-outline
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-bug-outline.svg
 * tags
 */
export const AntivirusOutlineIcon = ShieldBugOutlineIcon;
export default AntivirusOutlineIcon